import type { SearchFormSelectProps } from '../types/components/Select'
import { useFormItem } from '@autobid/nuxt-pinia-store/store/searchStore/useFormItem'
import { computed, ref } from 'vue'

export function useCustomSelect(context: SearchFormSelectProps['context']) {
  const value = useFormItem({
    key: String(context.node.name),
  })

  const query = ref('')

  const filteredOptions = computed(() => {
    if (!query.value.length) {
      return context.options
    }

    const filterOption = (item?: string | number) => {
      if (!item)
        return false

      String(item).toLowerCase().includes(query.value.toLowerCase())
    }

    return context.options?.filter((item) => {
      if (typeof item === 'string' || typeof item === 'number') {
        return filterOption(item)
      }

      return filterOption('name' in item ? item.name : item.label)
    })
  })

  return {
    options: context.options,
    value,
    filteredOptions,
    query,
  }
}
